module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/buttons/social-buttons/social-buttons.component.scss
// module id = ./src/app/features/buttons/social-buttons/social-buttons.component.scss
// module chunks = main